import React, { useState, useEffect, useRef } from "react";
import { ContentContainer } from "@layout";
import {
  Button,
  DownloadButton,
  LoadingComponent,
  NoDataFoundTemplate,
  Select,
} from "../../../components/core";
import axios from "axios";
import Papa from "papaparse";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Tag } from "primereact/tag";
import { getStatusWithSuspendedCheck } from "../../../utils/agent-helpers";

async function generateCSVData() {
  var url = `${process.env.REACT_APP_API_SUSPICIOUS_CSV}?${Date.now()}`;
  try {
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching CSV data:", error);
    return null;
  }
}

function formatDate(inputDate) {
  if (inputDate == null) {
    return "";
  }
  const date = new Date(inputDate);
  const options = { year: "numeric", month: "short", day: "numeric" };
  return date.toLocaleDateString(undefined, options);
}

// const removeSecondA = (e) => {
// 	if (e.Waybills && e.Waybills.length <= 1) {
// 		if (e.Waybills.charAt(1) === '*') {
// 			return e.Waybills.slice(0, 1) + e.Waybills.slice(2);
// 		}
// 	}
// 	return e.Waybills;
// }

export default function SuspiciousCourierReport() {
  const [csvData, setCsvData] = useState([]);
  const [loadOnce, setloadOnce] = useState(false);
  const [resultHeader, setresultHeader] = useState("");
  const dt = useRef(null);

  async function fetchData(numberOfDays) {
    setLoading(true);
    try {
      const response = await fetch(
        `${
          process.env.REACT_APP_website_api
        }v1/website/monitor/agent/suspicious/${numberOfDays}?${Date.now()}`,
      );
      const csvText = await response.text();
      console.log({ csvData });
      Papa.parse(csvText, {
        header: true,
        dynamicTyping: true,
        complete: (result) => {
          var tempData = [];
          result.data.forEach((k, i) => {
            // remove the first 2 digits of mobile no.
            if (k.Agent) {
              k.Agent = String(k.Agent).substring(2);
            }
            if (k.Recipient) {
              k.Recipient = String(k.Recipient).substring(2);
            }
            let obj = { ...k };
            // obj.Waybills = checkIfDigitsOnly(obj.Waybills);
            obj.blank = "";
            tempData.push(obj);
          });
          setCsvData(tempData);
          console.log(tempData);
          setLoading(false);
        },
      });
    } catch (error) {
      console.error("Error fetching or parsing CSV:", error);
    }
  }

  function checkIfDigitsOnly(waybill) {
    if (/^\d+$/.test(waybill)) {
      // return waybill + '*';
      try {
        return waybill.slice(0, 1) + "*" + waybill.slice(1);
      } catch (e) {
        return waybill;
      }
    }
    return waybill;
  }

  const formatDate1 = (e) => {
    return formatDate(e.Latest);
  };
  const [numberOfDays, setNumberOfDays] = React.useState("14");
  const [loading, setLoading] = React.useState(false);

  const getCurrentDateTime = () => {
    const options = {
      year: "numeric",
      month: "long",
      day: "2-digit",
      hour: "numeric",
      minute: "2-digit",
      hour12: true, // Use 12-hour format
    };

    // Get current date and time
    const currentDateTime = new Date().toLocaleString("en-US", options);
    return currentDateTime;
  };

  return (
    <ContentContainer containerTitle={"Suspicious Courier Report"}>
      <div>
        <div className="flex gap-2 mb-4">
          <p className="my-auto">Select Number of Days:</p>
          <Select
            className={"w-24"}
            onChange={(e) => {
              setNumberOfDays(e.target.value);
            }}
            value={numberOfDays}
            items={[
              { value: "7", name: "7 Days" },
              { value: "14", name: "14 Days" },
              { value: "21", name: "21 Days" },
              { value: "30", name: "30 Days" },
              { value: "60", name: "60 Days" },
            ]}
          />
          <Button
            className={"p-2"}
            value={"Search"}
            onClick={() => {
              setloadOnce(true);
              fetchData(numberOfDays);
              setresultHeader(numberOfDays);
            }}
            disabled={loading}
          />
          {loading && <LoadingComponent />}
        </div>
        <div>
          {csvData.length === 0 && !loading && loadOnce && (
            <div>
              <NoDataFoundTemplate width={56} height={56} />
            </div>
          )}
        </div>
        {csvData.length > 0 && (
          <>
            <div className="flex flex-row gap-1">
              <p>Total: </p>
              <p className="font-bold">{csvData.length}</p>
            </div>
            <DownloadButton
              dt={dt}
              id={"SUSPICIOUS COURIER REPORT"}
              csvOnly={true}
            />
            <div
              className="bg-primary-primaryYellow p-2 border-b-2 border-stone-400"
              id="SUSPICIOUS COURIER REPORT"
            >
              <p className="font-bold text-center">
                Suspicious Couriers for the last {resultHeader} Days
              </p>
              <DataTable
                paginatorTemplate="CurrentPageReport RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
                currentPageReportTemplate="Rows per page"
                paginator
                paginatorRight
                rowsPerPageOptions={[10, 20, 50]}
                rows={10}
                value={csvData}
                sortField="Packages"
                sortOrder={-1}
                tableStyle={{ minWidth: "50%" }}
                exportFilename="Suspicious Courier Report"
                stripedRows
                showGridlines
                className="border-2 border-stone-400"
                ref={dt}
              >
                <Column
                  header={"Agent"}
                  field="Agent"
                  sortable
                  style={{ minWidth: "10%" }}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                ></Column>
                <Column
                  header={"Agent Status"}
                  field="Verification"
                  sortable
                  style={{ minWidth: "10%" }}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                  body={(rowData) => {
                    const status = rowData.Verification?.toLowerCase().trim();
                    return (
                      <div className="flex justify-center">
                        <Tag
                          value={getStatusWithSuspendedCheck(
                            rowData.agentStatus,
                            rowData.comments,
                          )}
                          className={`${
                            rowData.agentStatus === 1
                              ? "bg-green-400" // Active
                              : rowData.agentStatus === -1 &&
                                  rowData.comments
                                    ?.toLowerCase()
                                    .includes("suspended")
                                ? "bg-orange-400" // Suspended
                                : rowData.agentStatus === -1
                                  ? "bg-red-400" // Blocked
                                  : "bg-gray-400" // Unknown (0 or any other value)
                          } text-secondary-purpleGray`}
                        />
                      </div>
                    );
                  }}
                ></Column>
                <Column
                  header={"Recipient"}
                  field="Recipient"
                  sortable
                  style={{ minWidth: "10%" }}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                ></Column>
                <Column
                  header={"Lockers"}
                  field="Lockers"
                  sortable
                  style={{ minWidth: "10%" }}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                ></Column>
                <Column
                  header={"Days"}
                  field="Days"
                  sortable
                  style={{ minWidth: "10%" }}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                ></Column>
                <Column
                  header={"Latest"}
                  field="Latest"
                  body={formatDate1}
                  sortable
                  style={{ minWidth: "10%" }}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                ></Column>
                <Column
                  header={"Packages"}
                  field="Packages"
                  sortable
                  style={{ minWidth: "10%" }}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                ></Column>
                <Column
                  header={"Waybills"}
                  field="Waybills"
                  sortable
                  // body={removeSecondA}
                  style={{ minWidth: "10%" }}
                  headerStyle={{ backgroundColor: "#facc15", color: "black" }}
                ></Column>
                <Column
                  field={"blank"}
                  header={`For the last ${resultHeader} Days from ${getCurrentDateTime()}`}
                  style={{ display: "none" }}
                ></Column>
              </DataTable>
            </div>
          </>
        )}
      </div>
    </ContentContainer>
  );
}
